import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { getThemeColors } from '../utils/themeColors';

interface CTACardProps {
  onClose: () => void;
}

const CTACard_1: React.FC<CTACardProps> = ({ onClose }) => {
  const { isDark, isHighContrast } = useTheme();
  const colors = getThemeColors('dark', isDark, isHighContrast);

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent('Olá! Gostaria de fazer uma cotação de seguro auto. Vi as avaliações e fiquei interessado!');
    window.open(`https://wa.me/41764791479?text=${message}`, '_blank');
  };

  return (
    <div style={{
      background: `linear-gradient(135deg, ${colors.primaryBg} 0%, ${colors.cardBg} 100%)`,
      borderRadius: 16,
      padding: 'clamp(1.5rem, 4vw, 2rem)',
      border: `2px solid ${colors.accentText}`,
      boxShadow: `0 10px 30px ${colors.shadowColor}`,
      margin: 'clamp(1rem, 3vw, 1.5rem) 0',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Background Pattern */}
      <div style={{
        position: 'absolute',
        top: -20,
        right: -20,
        width: 100,
        height: 100,
        background: colors.accentText,
        opacity: 0.1,
        borderRadius: '50%',
        zIndex: 0
      }} />
      
      <div style={{ position: 'relative', zIndex: 1 }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 'clamp(1rem, 3vw, 1.5rem)'
        }}>
          <div>
            <h3 style={{
              fontSize: 'clamp(1.2rem, 3.5vw, 1.5rem)',
              fontWeight: 700,
              color: colors.primaryText,
              margin: '0 0 0.5rem 0'
            }}>
              💬 Fale Conosco Agora!
            </h3>
            <p style={{
              fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
              color: colors.secondaryText,
              margin: 0,
              lineHeight: 1.4
            }}>
              Baseado nas avaliações que você viu, que tal fazer sua cotação personalizada? 
              <br />
              <strong>Você pode continuar lendo mais reviews ou fazer contato agora!</strong>
            </p>
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '1.2rem',
              color: colors.secondaryText,
              cursor: 'pointer',
              padding: '0.5rem',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.2s ease'
            }}
          >
            ✕
          </button>
        </div>

        <div style={{
          display: 'flex',
          gap: 'clamp(0.8rem, 2vw, 1rem)',
          flexWrap: 'wrap'
        }}>
          <button
            onClick={handleWhatsAppClick}
            style={{
              background: `linear-gradient(135deg, #25D366 0%, #128C7E 100%)`,
              color: 'white',
              border: 'none',
              borderRadius: 12,
              padding: 'clamp(0.8rem, 2.5vw, 1rem) clamp(1.5rem, 4vw, 2rem)',
              fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
              fontWeight: 600,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 15px rgba(37, 211, 102, 0.3)',
              flex: 1,
              minWidth: '200px'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 6px 20px rgba(37, 211, 102, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 15px rgba(37, 211, 102, 0.3)';
            }}
          >
            <span style={{ fontSize: '1.2rem' }}>💬</span>
            WhatsApp Rápido
          </button>
          
          <button
            onClick={onClose}
            style={{
              background: 'transparent',
              color: colors.primaryText,
              border: `2px solid ${colors.borderColor}`,
              borderRadius: 12,
              padding: 'clamp(0.8rem, 2.5vw, 1rem) clamp(1.5rem, 4vw, 2rem)',
              fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
              fontWeight: 600,
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              flex: 1,
              minWidth: '150px'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = colors.borderColor;
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'transparent';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            📖 Ver Mais Reviews
          </button>
        </div>
      </div>
    </div>
  );
};

export default CTACard_1; 